<button type="button" class="btn btn-success pull-right" data-bs-toggle="modal" data-bs-target="#auditModal" (click)="showDialogEvent()" title="Auditar...">
  <span class="fa fa-circle-info fa-lg "></span>
</button>


